import React from 'react';
import { Wrapper } from './PageSectionFooter.style';

const PageSectionFooter: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default PageSectionFooter;
